module.exports = __webpack_public_path__ + "img/asian.ebfb0ec7.jpg";